import { createSelector } from 'reselect'
import { b64ToBlob } from '../components/Common/imageCompressor'

const ofertaReducerSelector = state => state.ofertaReducer.getIn(["data"]).toJS()
export const ofertaSelector = createSelector(
    ofertaReducerSelector, (dataField) => {      
      return dataField
    }
  )

const oferta = state => state.OfertaReducer.getIn(["oferta"])
export const ofertaEditadoSelector = createSelector(
    oferta, (dataField) => {      
      return dataField.toJS ? dataField.toJS() : dataField
    }
  )
